import * as React from "react";
import { DatePicker } from "../../../../../../../react-core/Datepicker/DatePicker";
import { NumberTextBoxEditor } from "../../../../../../../react-core/Html/NumberTextBoxEditor";
import { ToggleButtonTwoOptions } from "../../../../../../../react-core/Html/ToggleButtonTwoOptions";
import { Numeric } from "../../../../../../../react-core/Html/Validation/RegExPatterns";
import { addYears } from "../../../../../../../react-core/utils/date";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { PlannedRetirement } from "../../../../../../../Wrap/Constants/Enums/PlannedRetirement";
import { ClientDetails } from "../../../../../../../Wrap/Models/Models/Processes/Quote/ClientDetails";
import { AnnuityAssumptions } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/AnnuityAssumptions";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { datePickerOptions } from "../../Resource/Contents";
import classNames from "classnames";

interface IRetirementAgeProps extends IProcessComponentProps {
    clientInfo: ClientDetails;
    data: AnnuityAssumptions;
}

interface IRetirementAgeState {}

export class RetirementAge extends ProcessComponent<IRetirementAgeProps, IRetirementAgeState> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        const { data, onChange, clientInfo } = this.props;
        let now = new Date();
        const nowWithoutMin = `${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}`;
        now = new Date(nowWithoutMin);
        const birthday = JsonDateParser.toDate(clientInfo.DateOfBirth);
        const inputSwitcherClasses = classNames(
            "input-switcher",
            data?.PlannedRetirement == PlannedRetirement.Date ? "control-size-160" : "control-size-100"
        );

        return (
            <fieldset>
                <div className={inputSwitcherClasses}>
                    {data?.PlannedRetirement == PlannedRetirement.Date ? (
                        <DatePicker
                            selected={JsonDateParser.toDateNoOffset(data?.PlannedRetirementDate)}
                            label={"Selected retirement"}
                            required={`Please enter selected retirement`}
                            atLeast={{
                                value: clientInfo?.DateOfBirth
                                    ? addYears(JsonDateParser.toDateNoOffset(clientInfo.DateOfBirth), 55)
                                    : now,
                                errorMessage: "Date must after 55th birthday",
                            }}
                            onChange={(v) => {
                                this.onDataChange(
                                    onChange,
                                    { PlannedRetirementDate: JsonDateParser.toJsonDateNoOffset(v) },
                                    data
                                );
                            }}
                            {...datePickerOptions}
                            formGroupCssWrapper="mb-10"
                        />
                    ) : (
                        <NumberTextBoxEditor
                            allowedCharacters={Numeric}
                            label={"Selected retirement"}
                            required={`Please enter selected retirement`}
                            value={
                                data?.PlannedRetirementDate == null
                                    ? null
                                    : JsonDateParser.toDateNoOffset(data.PlannedRetirementDate).getFullYear() -
                                      birthday.getFullYear()
                            }
                            atLeast={{ value: 55, errorMessage: "Age entered must be ≥ 55" }}
                            atMost={{ value: 99, errorMessage: "Maximum age entered must be no greater than 99." }}
                            onChange={(v) => {
                                this.onDataChange(
                                    onChange,
                                    {
                                        PlannedRetirementDate: new Date(
                                            birthday.getFullYear() + v,
                                            birthday.getMonth(),
                                            birthday.getDate()
                                        ),
                                    },
                                    data
                                );
                            }}
                            cssWrapper="mb-10 text-align-center"
                        />
                    )}
                    <ToggleButtonTwoOptions
                        optionOne="Age"
                        optionTwo="Date"
                        value={data?.PlannedRetirement == PlannedRetirement.Date}
                        onChange={(v) =>
                            this.onDataChange(
                                onChange,
                                {
                                    PlannedRetirement: v ? PlannedRetirement.Date : PlannedRetirement.Age,
                                    PlannedRetirementDate: now,
                                },
                                data
                            )
                        }
                    />
                </div>
            </fieldset>
        );
    }
}
